import { tesaDarkRedError } from "../../../styles/colors";

const confirmationDialogConfig = {
  headline: "You have unsaved changes",
  text: "If you continue, your current changes to the laboratory will be discarded.",
  confirmText: "Save",
  additionalAction: {
    id: "DISCARD",
    text: "Discard",
    textColor: tesaDarkRedError,
  },
};

export default confirmationDialogConfig;
